import TreeStore from 'stores/TreeStore';
import TnvedNode from 'models/TnvedNode';

const NAMESPACE = 'tnved';

export default class TnvedTreeStore extends TreeStore {

  isInfoSupported = true

  nodes = this.collection({
    model: TnvedNode
  })

  foundNodes = this.collection({
    model: TnvedNode
  })

  async fetchChildNodes(parentNode) {
    return await super.fetchChildNodes(parentNode, NAMESPACE);
  }

  async fetchParents(parentNode) {
    return await super.fetchParents(parentNode, NAMESPACE);
  }

  async search(term) {
    return await super.search(term, NAMESPACE);
  }

  toString() {
    return NAMESPACE;
  }

}



// WEBPACK FOOTER //
// ./src/stores/TnvedTreeStore.js